/*
 * SDK连接相关
 */
import { Message, MessageBox } from "element-ui";
import router from "@/router";

import cookie from "@/utils/cookie.js";
import config from "@/config/config";
import util from "@/utils";
import store from "../";
import { onFriends, onSyncFriendAction } from "./friends";
// import {onRobots} from './robots'
// import {onBlacklist, onMarkInBlacklist} from './blacks'
import { onMyInfo, onUserInfo } from "./userInfo";
import { onSessions, onUpdateSession } from "./session";
import { onRoamingMsgs, onOfflineMsgs, onMsg } from "./msgs";
import {
  onSysMsgs,
  onSysMsg,
  onSysMsgUnread,
  onCustomSysMsgs,
} from "./sysMsgs";
// import { onTeams, onSynCreateTeam, onCreateTeam, onUpdateTeam, onTeamMembers, onUpdateTeamMember, onAddTeamMembers, onRemoveTeamMembers, onUpdateTeamManagers, onDismissTeam, onUpdateTeamMembersMute, onTeamMsgReceipt} from './team'
import { signalingNotifyHandler } from "./initWebRtc";
import SDK from "../../sdk/NIM_Web_NIM_v6.9.0";

// 重新初始化 NIM SDK
export function initNimSDK({ state, commit, dispatch }, loginInfo) {
  if (!loginInfo.uid || !loginInfo.sdktoken) {
    // util.clearStorage();
    // Message.error({
    //   message: "登录记录已过期,请重新登录",
    // });
    setTimeout(() => {
      router.push({
        path: "/login",
      });
    }, 1500);
  }
  if (state.nim) {
    state.nim.disconnect();
  }
  dispatch("showLoading");
  // 初始化SDK
  return new Promise((ok, no) => {
    if(!loginInfo.uid) return // 添加判断 去除因为缺少数据导致的报错
    window.nim = state.nim = NIM.getInstance({
      // debug: true,
      appKey: config.appkey,
      account: loginInfo.uid,
      token: loginInfo.sdktoken,
      transports: ["websocket"],
      db: config.useDb,
      syncSessionUnread: true,
      syncRobots: true,
      autoMarkRead: true, // 默认为true
      onconnect: function onConnect(event) {
        ok("ok");
        if (loginInfo) {
          // 连接上以后更新uid
          commit("updateUserUID", loginInfo);
        }
      },
      onerror: function onError(event) {
        console.log("im-error:", event);
        location.href = config.loginUrl;
      },
      onwillreconnect: function onWillReconnect() {},
      ondisconnect: function onDisconnect(error) {
        switch (error.code) {
          // 账号或者密码错误, 请跳转到登录页面并提示错误
          case 302:
            // Message.error({
            //   message: "登录记录已过期,请重新登录",
            // });
            setTimeout(() => {
              router.push({
                path: "/login",
              });
            }, 1500);
            break;
          // 被踢, 请提示错误后跳转到登录页面
          case "kicked":
            let map = {
              PC: "电脑版",
              Web: "网页版",
              Android: "手机版",
              iOS: "手机版",
              WindowsPhone: "手机版",
            };
            let str = error.from;
            let errorMsg = `你的帐号于${util.formatDate(new Date())}被${map[
              str
            ] || "其他端"}踢出下线，请确定帐号信息安全!`;
            // Message.error( {
            //   message: `您的帐号于${util.formatDate( new Date() )}被${( map[str] || '其他端' )}踢出下线，请确定帐号信息安全!`
            // } );
            MessageBox.alert(
              `您的帐号于${util.formatDate(new Date())}被${map[str] ||
                "其他端"}踢出下线，请确定帐号信息安全!`,
              "提醒",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  const that = this;
                  router.push({
                    path: "/login",
                  });
                  util.removeStore("user_token");
                  util.removeStore("username");
                  util.removeStore("userInfo");
                  util.removeStore("user_id");
                  util.removeStore("userType");
                  util.removeStore("user_mobile");
                  const nim = state.nim;
                  nim && nim.disconnect();
                  cookie.delCookie("uid");
                  cookie.delCookie("sdktoken");
                  location.reload();
                },
              }
            );
            // router.push({
            //   path:'/index/work/consultation'
            // })
            // router.push( {
            //   path: "/login",
            // } );
            // pageUtil.turnPage(errorMsg, 'login')
            break;
          default:
            break;
        }
      },
      // // 多端登录
      // onloginportschange: onLoginPortsChange,
      // 用户关系及好友关系
      // onblacklist: onBlacklist,
      // onsyncmarkinblacklist: onMarkInBlacklist,
      // onmutelist: onMutelist,
      // onsyncmarkinmutelist: onMarkInMutelist,
      onfriends: onFriends,
      onsyncfriendaction: onSyncFriendAction,
      // 机器人
      // onrobots: onRobots,
      // 用户名片 - actions/userInfo
      onmyinfo: onMyInfo,
      onupdatemyinfo: onMyInfo,
      onusers: onUserInfo,
      onupdateuser: onUserInfo,
      // // 群组
      // onteams: onTeams,
      // onsynccreateteam: onSynCreateTeam,
      // syncTeams: true,
      // onteammembers: onTeamMembers,
      // onCreateTeam: onCreateTeam,
      // onDismissTeam: onDismissTeam,
      // onUpdateTeam: onUpdateTeam,
      // onAddTeamMembers: onAddTeamMembers,
      // onRemoveTeamMembers: onRemoveTeamMembers,
      // onUpdateTeamManagers: onUpdateTeamManagers,
      // onupdateteammember: onUpdateTeamMember,
      // onUpdateTeamMembersMute: onUpdateTeamMembersMute,
      // onTeamMsgReceipt: onTeamMsgReceipt,
      // // 会话
      onsessions: onSessions,
      onupdatesession: onUpdateSession,
      // // 消息
      onroamingmsgs: onRoamingMsgs,
      onofflinemsgs: onOfflineMsgs,
      onmsg: onMsg,
      // // 系统通知
      onsysmsg: onSysMsg,
      onofflinesysmsgs: onSysMsgs,
      onupdatesysmsg: onSysMsg, // 通过、拒绝好友申请会收到此回调

      onsysmsgunread: onSysMsgUnread,
      onupdatesysmsgunread: onSysMsgUnread,

      onofflinecustomsysmsgs: onCustomSysMsgs,
      oncustomsysmsg: onCustomSysMsgs,
      // // 同步完成
      onsyncdone: function onSyncDone() {
        dispatch("hideLoading");
        // 说明在聊天列表页
        if (store.state.currSessionId) {
          dispatch("setCurrSession", store.state.currSessionId);
        }
      },
    });
    window.nim.useDb = config.useDb;
    window.nim.on("signalingNotify", signalingNotifyHandler);
  });
}
export function logout({ commit, state }) {
  const nim = state.nim;
  nim && nim.disconnect();
  location.reload();
}
